export default {
  data(){
    return {

    }
  },
  created: function(){
    this.$store.watch(() => this.isPresetUpdated(), (isPresetUpdated) => this.clearFixedColumns(isPresetUpdated));
  },
  computed: {
    fixedColumns: {
      set(value){
        this.$store.dispatch(this.namespace + '/setFixedColumns', value);
      },
      get(){
        return this.$store.getters[this.namespace + '/getFixedColumns'];
      }
    },
    isAnyFixedColumnsExist: function(){
      return (this.fixedColumns.length > 0);
    }
  },
  methods: {
    isPresetUpdated: function(){
      return this.$store.getters[this.namespace + '/isPresetUpdated'];
    },
    updatePresetStatus: function(){
      return this.$store.getters[this.namespace + '/updatePresetStatus'];
    },
    isColumnFixed: function(columnIndex){
      if (this.fixedColumns !== undefined && this.fixedColumns.find(index => index == columnIndex) != undefined)
      {
        return true;
      }

      return false;
    },
    makeColumnFixed: function(columnIndex){
      if (this.fixedColumns !== undefined)
      {
        if (this.isColumnFixed(columnIndex))
        {
          let key = this.fixedColumns.findIndex(index => index === columnIndex);

          if (key != -1)
          {
            this.fixedColumns.splice(key, 1);

            if (this.hoveredColumns !== undefined && columnIndex !== null)
            {
              this.removeHovering(columnIndex);
            }
          }
        }
        else
        {
          this.fixedColumns.push(columnIndex);
        }
      }
    },
    clearFixedColumns(status) {
      if (this.fixedColumns !== undefined)
      {
        if (status)
        {
          this.fixedColumns = [];
        }

        this.updatePresetStatus(false);
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/reports/mixins/fixTableMixin.js